/**
 * Admin Dashboard Page
 * - Main landing page after login
 * - Displays key statistics and metrics
 * - Shows recent activity and charts
 * - Entry point for admin functionality
 */

import React from "react";
import AdminPanelContent from "../../components/AdminPanel/AdminPanelContent";

const AdminPanel = () => {
  return (
    <div className="mx-auto max-w-7xl px-6 py-4">
      <AdminPanelContent />
    </div>
  );
};

export default AdminPanel;
